import { Card, CardContent, CardHeader, CardTitle } from "@/shared/ui/card";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { TrendingUp } from "lucide-react";

export function ProductionTrendWidget() {
  const data = [
    { time: "00:00", planned: 95, actual: 92, oee: 84 },
    { time: "04:00", planned: 95, actual: 94, oee: 86 },
    { time: "08:00", planned: 95, actual: 96, oee: 88 },
    { time: "12:00", planned: 95, actual: 93, oee: 85 },
    { time: "16:00", planned: 95, actual: 95, oee: 87 },
    { time: "20:00", planned: 95, actual: 91, oee: 83 },
  ];

  return (
    <Card className="h-full flex flex-col">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <TrendingUp className="h-4 w-4" />
          Production Trend (24h)
        </CardTitle>
      </CardHeader>
      <CardContent className="flex-1">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
            <XAxis dataKey="time" fontSize={12} />
            <YAxis fontSize={12} domain={[0, 100]} />
            <Tooltip
              contentStyle={{
                backgroundColor: "var(--card)",
                border: "1px solid var(--border)",
                borderRadius: "8px",
              }}
            />
            <Legend />
            <Line type="monotone" dataKey="planned" stroke="var(--chart-3)" strokeWidth={2} name="Planned %" />
            <Line type="monotone" dataKey="actual" stroke="var(--success)" strokeWidth={2} name="Actual %" />
            <Line type="monotone" dataKey="oee" stroke="var(--chart-4)" strokeWidth={2} name="OEE %" />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
